/**
 * Parâmetros do controle de sessão, num lugar só.
 *
 * O modelo é de sessão deslizante por atividade: enquanto o usuário usa o
 * sistema, o token é renovado silenciosamente e ele nunca é deslogado. Só
 * depois de IDLE_LIMITE_MS sem atividade aparece o aviso, com IDLE_AVISO_MS
 * para responder.
 */
export const SESSAO = {
  /** Tempo sem atividade até o aviso de encerramento. */
  IDLE_LIMITE_MS: 4 * 60 * 60 * 1000,
  /** Duração da contagem regressiva do aviso. */
  IDLE_AVISO_MS: 2 * 60 * 1000,
  /** Varredura periódica. Baixa frequência de propósito: navegadores estrangulam
   *  timers em abas ocultas, então o tick é complementado por visibilitychange. */
  TICK_MS: 30 * 1000,
  /** Intervalo mínimo entre gravações de "última atividade" no localStorage. */
  ATIVIDADE_THROTTLE_MS: 10 * 1000,
  /** Fração da vida do token a partir da qual vale a pena renovar. */
  RENOVAR_RATIO: 0.5,
  /** Piso do limiar de renovação, para tokens de vida curta. */
  RENOVAR_MIN_RESTANTE_MS: 5 * 60 * 1000,
  /** Vida presumida do token quando ela não pode ser medida (primeira leitura
   *  do storage, sem saber quando o token foi emitido). */
  VIDA_TOKEN_PADRAO_MS: 60 * 60 * 1000,
  /** Margem de relógio ao considerar a sessão expirada. */
  CLOCK_SKEW_MS: 30 * 1000,
  /** Validade do lock que evita renovações simultâneas entre abas. */
  RENOVACAO_LOCK_MS: 15 * 1000,
} as const;

export const CHAVES = {
  USER: "@MatriculaWeb:user",
  UNIDADE: "UnidadeLogada",
  ULTIMA_ATIVIDADE: "@MatriculaWeb:ultimaAtividade",
  RENOVACAO_LOCK: "@MatriculaWeb:renovando",
  /** Rota a restaurar após relogin. Fica em sessionStorage (por aba). */
  REDIRECT: "@MatriculaWeb:redirect",
} as const;

/** Acesso ao localStorage tolerante a modo privativo/quota estourada. */
export const storage = {
  ler(chave: string): string | null {
    try {
      return localStorage.getItem(chave);
    } catch {
      return null;
    }
  },
  lerJson(chave: string): any | null {
    const bruto = storage.ler(chave);
    if (!bruto) return null;
    try {
      return JSON.parse(bruto);
    } catch {
      return null;
    }
  },
  gravar(chave: string, valor: string): void {
    try {
      localStorage.setItem(chave, valor);
    } catch {
      // Sem storage disponível o controle de sessão degrada para "só nesta aba".
    }
  },
  remover(chave: string): void {
    try {
      localStorage.removeItem(chave);
    } catch {
      // idem
    }
  },
};
